export const CONTACT_NEXT_STEP_LIMIT = 5;
